import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.jsx"
import "./index.css"
import { Provider } from "react-redux"
import store from "./data/store.js"
import * as Sentry from "@sentry/react"
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType, useRoutes } from "react-router-dom"

Sentry.init({
    dsn: "https://13e96310f08108abe9d16e62e6a23b77@o1127737.ingest.us.sentry.io/4507347209551872",
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
        }),
        Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    beforeSend(event) {
        let url = event?.request?.url
        if (url?.includes("localhost")) {
            return null
        }
        return event
    },
    release: "gai-small-contractors@1.0.0",
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    disableServerWebpackPlugin: true
})

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <div className="container-fluid p-0">
            <App />
        </div>
    </Provider>
)
